// extracted by mini-css-extract-plugin
export default {"root":"ViolatedFilename__root--3hsI0","rootResponsive":"ViolatedFilename__rootResponsive--1d7Fz"};